module.exports = __webpack_public_path__ + "img/knowledge-lib-icon.c8218c50.svg";